import React from "react";
import {
  ButtonColour,
  ButtonSize, CallToActionLink,
} from "@trussle/external-components";
import classnames from "classnames";
import kebabCase from "lodash.kebabcase";

import { IContentfulRichText } from "../../../../types/IContentfulRichText";
import { IComparisonCard } from "../../../../types/IComparisonCard";
import { IContentfulBackgroundColour } from "../../../../types/IContentfulBackgroundColour";
import { ICTA } from "../../../../types/ICTA";
import { ComparisonCard } from "../../../ComparisonCard";
import { Heading } from "../../../Heading";
import { RichText } from "../../../RichText";

import "./styles.scss";

export interface IComparisonPanelV1Props {
  backgroundColour: IContentfulBackgroundColour;
  content: IContentfulRichText | null;
  callToAction?: ICTA;
  comparisonCards: IComparisonCard[];
  title?: string;
  headingType?: string;
  link?: { text: string; url: string };
}

export const ComparisonPanelV1 = ({
  title, backgroundColour, content, callToAction, comparisonCards, headingType, link,
}: IComparisonPanelV1Props) => {
  const linkClasses = classnames("comparisonPanel__link", {
    "comparisonPanel__link--white": backgroundColour === "navy",
  });

  const titleClasses = classnames("comparisonPanel__title", {
    "comparisonPanel__title--white": backgroundColour === "navy",
  });

  return (
    <div
      role="region"
      aria-label="Comparison panel"
      className="comparisonPanel"
    >
      <div className="comparisonPanel__contentContainer">
        {title && (
          <Heading
            {...(title && {
              id: kebabCase(title.toLowerCase()),
            })}
            className={titleClasses}
            type={headingType}
          >
            {title}
          </Heading>
        )}
        {content && (
          <RichText
            className="comparisonPanel__content"
            contrastText={backgroundColour === "navy"}
            content={content}
          />
        )}
        {link && (
          <div className="comparisonPanel__link-container">
            <a className={linkClasses} href={link.url}>
              {`${link.text} >`}
            </a>
          </div>
        )}
        {callToAction && (
          <div className="comparisonPanel__cta">
            <CallToActionLink
              classOverrides={{
                anchor: "comparisonPanel--full-width",
              }}
              href={callToAction.url}
              size={ButtonSize.Large}
              colour={ButtonColour.Secondary}
            >
              {callToAction.title}
            </CallToActionLink>
          </div>
        )}
      </div>
      <div className="comparisonPanel__comparisonCards">
        {comparisonCards.map((card, index) => (
          <ComparisonCard
            key={index}
            classNames="comparisonPanel__comparisonCard"
            parentBgColour={backgroundColour}
            title={card.title}
            items={card.items}
          />
        ))}
      </div>
    </div>
  );
};
